<mat-icon
  [class.Icon--small]="size() === IconSize.Small"
  [class.Icon--medium]="size() === IconSize.Medium"
  [class.Icon--large]="size() === IconSize.Large"
  [class.Icon--xlarge]="size() === IconSize.XLarge"
><ng-content></ng-content></mat-icon>
